export default "__VITE_ASSET__EludVcPM__"